import React from "react";
import { fetchActiveLoanSnapShot } from "../../store/reducers/dashboardSlice/api";
import { gridColumns_activeLoanSnapshot } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import useFetchTableData from "../../useFetchTableData";

const ActiveLoanSnapShotTable = ({ className = "" }) => {
  const { data, status, retry } = useFetchTableData(
    fetchActiveLoanSnapShot,
    "activeLoanSnapShot"
  );

  if (!data || data?.length === 0) {
    return null;
  }

  return (
    <CommonGrid
      className={`col-sm-6 ${className}`}
      title={"Active Loans Snapshot"}
      gridColumns={gridColumns_activeLoanSnapshot}
      columnData={data}
      filterOption={[
        { name: "Month Filter", key: "next_due_date", type: "month" },
      ]}
      tableTotal={["origbal", "principal"]}
      status={status}
      onRetry={retry}
      isDifferent={true}
    />
  );
};

export default ActiveLoanSnapShotTable;
